import { createReducer } from '@reduxjs/toolkit';
import { userUtmTagsUpdated } from './actions/userUtmTagsUpdated';
import { userUtmTagsInitialState } from './state';

export const userUtmTagsReducer = createReducer(userUtmTagsInitialState, (builder) => {
  builder.addCase(userUtmTagsUpdated, (state, { payload }) => {
    state.tags = payload;
  });
});
